import React from 'react';
import { ArrowLeft } from 'lucide-react';
interface MobileHeaderProps {
  title: string;
  onBack?: () => void;
  right?: React.ReactNode;
}
export function MobileHeader({
  title,
  onBack,
  right
}: MobileHeaderProps) {
  return <header className="flex h-14 shrink-0 items-center gap-2 bg-[#003B71] px-3 text-white" data-id="element-391" data-mp="1a5baf3ap8d0u">
      {onBack && <button onClick={onBack} aria-label="ফিরে যান" className="rounded-full p-1.5 hover:bg-white/10" data-id="element-392" data-mp="157j9xkvznil1">
          <ArrowLeft className="h-5 w-5" data-id="element-393" data-mp="106lpt2rf4egw" />
        </button>}
      <h1 className="flex-1 truncate text-[16px] font-semibold" data-id="element-394" data-mp="w6bm5wr3m057">{title}</h1>
      {right}
    </header>;
}